import script from "./SpmbRedirectPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpmbRedirectPopup.vue?vue&type=script&setup=true&lang=ts"

import "./SpmbRedirectPopup.vue?vue&type=style&index=0&id=9e6c3436&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.1.6__webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e6c3436"]])

export default __exports__